import { useEffect } from 'react';
export var useTabChange = function useTabChange(_ref) {
  var shouldSkip = _ref.shouldSkip,
      onHidden = _ref.onHidden,
      onShow = _ref.onShow;
  useEffect(function () {
    if (shouldSkip) return;

    var handleVisibilityChange = function handleVisibilityChange() {
      return document.visibilityState === 'hidden' ? onHidden() : onShow();
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return function () {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [shouldSkip, onHidden, onShow]);
};